import "../styles/footer.scss"
import {Link} from "react-router-dom";

export const GetBackFooterMob = ({folderName, heading, link}) => {
    return (
        <footer className="gb-footer-mob">
            <Link to={`/${link}`} className="gb-footer-mob__wrapper">
                <p>View More</p>
                <p>{heading}</p>
                <img src={`${folderName}/FooterMob.jpeg`} alt="#"/>
            </Link>

            <img className="gb-footer-mob__arrow" src="arrow_bold.svg" alt="#"/>
        </footer>
    )
}